// @flow
import * as React from 'react';
import Slick from 'react-slick';
import ClientSide from './ClientSide';

import '../../../static/scss/components/slider.scss';

const defaultSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

type Props = {
  settings?: any,
  children?: any
};

const Slider = ({ children, settings }: Props) => {
  const allSettings = { ...defaultSettings, ...settings };

  return (
    <ClientSide>
      <Slick {...allSettings}>{children}</Slick>
    </ClientSide>
  );
};

Slider.defaultProps = {
  settings: {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  },
  children: null
};

export default Slider;
